$(document).ready(function () {
  // Check if the newsletter popup exists
  if ($(".newsletter-popup-wrapper").length === 0) {
    return; // Exit if the popup doesn't exist
  }

  // Function to set a cookie
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  // Function to get a cookie value by name
  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
  function checkFormSuccessOnLoad() {
    const frequency = $(".newsletter-popup-wrapper").data("popup-frequency");

    // Wait briefly to allow for any dynamic content loading
    setTimeout(function () {
      const formHasSuccess = $(".newsletter-form__message--success");

      if (formHasSuccess.length) {
        console.log("Success detected on page load - setting cookie");
        setCookie("frequency", true, frequency); // Set cookie
        $(".newsletter-popup-wrapper .modal").removeClass("is-visible"); // Hide popup
      } else {
        console.log(
          "No success message found on page load - not setting cookie"
        );
      }
    }, 500); // Adjust delay if needed
  }
  function initNewsletterPopup() {
    const $newsletterPopup = $(".newsletter-popup-wrapper");
    const testMode = $newsletterPopup.data("popup-test");
    const delay = $newsletterPopup.data("popup-delay") * 1000;
    const frequency = $newsletterPopup.data("popup-frequency");

    // Show popup in test mode after a delay
    if (testMode) {
      setTimeout(function () {
        $(".newsletter-popup-wrapper .modal").addClass("is-visible");
        $("body").addClass("no-scroll");
      }, delay);
    } else {
      // Check cookie frequency
      setTimeout(function () {
        const days = getCookie("frequency");
        if (!days) {
          $(".newsletter-popup-wrapper .modal").addClass("is-visible");
          $("body").addClass("no-scroll");
        }
      }, delay);
    }

    // Handle form submission
    $(".newsletter-form").on("submit", function () {
      // Prevent form's default submit action

      // Simulate form submission processing, for example an AJAX call
      setTimeout(function () {
        const formHasSuccess = $(".newsletter-form__message--success");

        if (formHasSuccess.length) {
          console.log("Success - setting cookie");
          setCookie("frequency", true, frequency); // Set cookie after successful form submission
          $(".newsletter-popup-wrapper .modal").removeClass("is-visible"); // Hide popup
        } else {
          console.log("Submission failed - not setting cookie");
        }
      }, 500); // Adjust delay if needed based on when success message appears
    });
    $(document).on("click", function (e) {
      if (!$(e.target).closest(".modal-wrapper").length) {
        $(".newsletter-popup-wrapper .modal").removeClass("is-visible");
        $("body").removeClass("no-scroll");
        setCookie("frequency", true, frequency);
      }
    });
  }
  initNewsletterPopup();
  checkFormSuccessOnLoad();
});
